export default "__VITE_ASSET__CeoT5Mcs__"